import { useTranslation } from "react-i18next";

import { Modal, CardContent, Typography, WhiteSpace, ModalProps, Loader } from ".";

export interface LoadingModalProps extends ModalProps {
  title?: React.ReactNode;
}

export const LoadingModal = ({ title, onClose, ...props }: LoadingModalProps) => {
  const { t } = useTranslation("common");
  return (
    <Modal size="sm" onClose={onClose} {...props}>
      <CardContent>
        <WhiteSpace v="2rem" />

        <Typography align="center">
          <Loader spread size="md" />
          <h2>{title || t("wait_payment")}</h2>
          <WhiteSpace v="1rem" />
        </Typography>

        <WhiteSpace v="2rem" />
      </CardContent>
    </Modal>
  );
};
